import { FunnelEventMarketing } from './funnel-event-marketing';

export const funnelEventMarketingToEventProperty: Record<FunnelEventMarketing, string[]> = {
  [FunnelEventMarketing.NursingAreaChosen]: ['nursing_area'],
  [FunnelEventMarketing.EmployerTypeChosen]: ['employer_type'],
  [FunnelEventMarketing.DesiredPositionChosen]: ['position'],
  [FunnelEventMarketing.IsDeputyPositionChosen]: ['position_type'],
  [FunnelEventMarketing.HasNursingApprenticeshipAnswered]: ['nursing_apprenticeship_type'],
  [FunnelEventMarketing.HasApprenticeshipAnswered]: ['apprenticeship_completed'],
  [FunnelEventMarketing.Has3YearExamAnswered]: ['three_year_exam_completed'],
  [FunnelEventMarketing.HasCertificationAnswered]: ['certification_completed'],
  [FunnelEventMarketing.YearsOfExperienceAnswered]: ['years_of_experience_values'],
  [FunnelEventMarketing.HasFurtherQualificationsAnswered]: ['has_further_qualifications'],
  [FunnelEventMarketing.FurtherQualificationsChosen]: ['further_qualifications_values'],
  [FunnelEventMarketing.RecognitionUpdated]: ['qualification_recognition'],
  [FunnelEventMarketing.DesiredUnitsChosen]: ['desired_units_values'],
  [FunnelEventMarketing.HasDriversLicenseAnswered]: ['has_drivers_license'],
  [FunnelEventMarketing.AreaStepViewed]: [],
  [FunnelEventMarketing.AreaStepCompleted]: ['areas_count'],
  [FunnelEventMarketing.AreaStepSkipped]: [],
  [FunnelEventMarketing.LocationChosen]: [
    'administrative_area_level_3',
    'city',
    'country',
    'formatted_address',
    'lat',
    'lng',
    'place_id',
    'postal_code',
    'street_address_and_number',
    'big_city',
  ],
  [FunnelEventMarketing.GermanLevelChosen]: ['speaking_level'],
  [FunnelEventMarketing.EmploymentRelationshipChosen]: ['employment_relationship_type'],
  [FunnelEventMarketing.EmploymentScheduleChosen]: ['employment_schedule_type', 'employment_weekly_hours'],
  [FunnelEventMarketing.CanStartOnChosen]: ['desired_start_time'],
  [FunnelEventMarketing.RegistrationCompleted]: [
    'first_name',
    'last_name',
    'email',
    'phone_number',
    'candidate_priority',
    'tracking_priority',
    'nursing_area',
  ],
  [FunnelEventMarketing.RegistrationCompletedPraxia]: [
    'first_name',
    'last_name',
    'email',
    'phone_number',
    'candidate_priority',
    'tracking_priority',
    'nursing_area',
  ],
  [FunnelEventMarketing.RegistrationStarted]: ['funnel'],
  [FunnelEventMarketing.RegistrationStep1Completed]: ['first_name', 'last_name', 'email'],
  [FunnelEventMarketing.RegistrationMultiposting]: [
    'first_name',
    'last_name',
    'email',
    'phone_number',
    'candidate_priority',
    'tracking_priority',
    'nursing_area',
  ],
  [FunnelEventMarketing.JobYearsOfExperienceAnswered]: ['job_years_of_experience'],
  [FunnelEventMarketing.PersonalDataProvided]: ['personal_data'],
  [FunnelEventMarketing.PhoneNumberProvided]: ['phone_number'],
  [FunnelEventMarketing.CvFilesUploaded]: ['cv_files'],
  [FunnelEventMarketing.ExternalRegistrationCompleted]: ['external_registration'],
  [FunnelEventMarketing.JobQualificationProvided]: ['job_qualification'],
  [FunnelEventMarketing.HighlightJobTitleChosen]: ['highlight_job_title'],
  [FunnelEventMarketing.CaregiverQualificationAnswered]: ['caregiver_qualification'],
};

export const getEventProperty = (eventName: FunnelEventMarketing) => funnelEventMarketingToEventProperty[eventName]?.[0];
